module.exports = __webpack_public_path__ + "img/Type_Bug.213f1193.png";